<template>
  <b-modal id="edit-profile-modal" ref="editProfileModal" title="แก้ไขข้อมูลส่วนตัว" size="lg" ok-title="บันทึกข้อมูล" cancel-title="ยกเลิก" @ok="submit">
    <b-form-group label-cols="4" label-cols-lg="3" label="ชื่อ-สกุล (ภาษาอังกฤษ)">
      <div class="row">
        <div class="col-6">
          <b-form-input :value="$auth.user().enFirstName" disabled />
        </div>
        <div class="col-6">
          <b-form-input :value="$auth.user().enLastName" disabled />
        </div>
      </div>
    </b-form-group>
    <b-form-group label-cols="4" label-cols-lg="3" label="ชื่อ-สกุล (ภาษาไทย)">
      <div class="row">
        <div class="col-6">
          <b-form-input v-model="form.thFirstName" placeholder="ชื่อและคำนำหน้าชื่อ" />
        </div>
        <div class="col-6">
          <b-form-input v-model="form.thLastName" placeholder="นามสกุล" />
        </div>
      </div>
    </b-form-group>
    <b-form-group label-cols="4" label-cols-lg="3" label="เบอร์โทรศัพท์">
      <b-form-input v-model="form.tel" />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  data () {
    return {
      form: {
        thFirstName: this.$auth.user().firstName,
        thLastName: this.$auth.user().lastName,
        tel: this.$auth.user().tel
      }
    }
  },
  methods: {
    async submit (event) {
      event.preventDefault()

      await this.$axios.patch('/user', {
        firstName: this.form.thFirstName,
        lastName: this.form.thLastName,
        tel: this.form.tel
      }).then(() => {
        this.$bvToast.toast('บันทึกการเปลี่ยนแปลงสำเร็จ', {
          title: 'แจ้งเตือน',
          variant: 'success',
          solid: true
        })

        this.$nextTick(() => { this.$refs.editProfileModal.hide() })
      }).catch(_ => {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      })

      this.$auth.fetch()
    }
  }
}
</script>
